import { createSlice } from "@reduxjs/toolkit";

const authSlice = createSlice({
  name: "auth",
  initialState: {
    token: typeof window !== "undefined" ? localStorage.getItem("token") : null,
    user: {},
    permissions: [],
    session: null,
  },
  reducers: {
    setPermission: (state, action) => {
      state.permissions = action.payload;
    },
    login: (state, action) => {
      state.token = action.payload.token;
      state.user = action.payload.user;
      state.permissions = action.payload.permissions;
      state.session = action.payload.session || null;
      localStorage.setItem("token", action.payload.token);
      if (action.payload.session?.session_key) {
        localStorage.setItem("session_key", action.payload.session.session_key);
      }
    },
    logout: (state) => {
      localStorage.removeItem("token");
      localStorage.removeItem("session_key");
      localStorage.clear()
      state.token = undefined;
      state.user = undefined;
      state.permissions = undefined;
      state.session = undefined;
    },
    user: (state, action) => {
      state.user = action.payload
    }
  },
});

export const { login, logout, user, setPermission } = authSlice.actions;

export default authSlice.reducer;
